import { render, staticRenderFns } from "./PromotionOctober2.vue?vue&type=template&id=734509d8&scoped=true&"
import script from "./PromotionOctober2.vue?vue&type=script&lang=js&"
export * from "./PromotionOctober2.vue?vue&type=script&lang=js&"
import style0 from "./PromotionOctober2.vue?vue&type=style&index=0&id=734509d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "734509d8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
